module.exports = __webpack_public_path__ + "img/202411_08.9f21f256.jpg";